import { useMatch } from "react-router";

import { ADVERTISER_ROUTE, INFO_STEP } from "../helpers/constants";

export const usePathname = () => {
	const { params } = useMatch(ADVERTISER_ROUTE);

	const { step } = params;
	if (step == null) return INFO_STEP;

	return step;
};
